var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('empty-header',{attrs:{"componentPath":_vm.component,"show-short-graph":_vm.page === 'Portfolio'}})
}
var staticRenderFns = []

export { render, staticRenderFns }